import { Injectable } from '@angular/core';

declare let jquery:any;
declare let $ :any;
declare let swal:any;

@Injectable()
export class UtilsService {

  page;

  possibleLimit = [
    {value: 10, text: '10'},
    {value: 25, text: '25'},
    {value: 50, text: '50'},
    {value: 100, text: '100'},
  ];

  constructor() {}

  displayNotif(message: string, type: string, timer = 2000): void {
    $.notify({
      icon: 'fa fa-bell-o',
      message: message
    },{
      type: type,
      timer: timer,
      icon_type: 'class',
      offset: {y: 100, x: 20}
    });
  }

  scrollTop() {

    var self = this;
    self.page = $("html, body");

    self.page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function(){
      self.page.stop();
    });

    self.page.stop().animate({scrollTop: $('.top-admin').offset().top}, 300, function() {
      self.page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/utils.service.ts